export type ProfileRole = "parent" | "enfant" | "enseignant" | "eleve";

export type AgeBand = "6-8" | "9-11" | "12-15" | "16-plus";

export function computeAgeBand(age?: number | null): AgeBand | undefined {
  if (age == null) return undefined;
  if (age < 6) return undefined;
  if (age <= 8) return "6-8";
  if (age <= 11) return "9-11";
  if (age <= 15) return "12-15";
  return "16-plus";
}
